import React, { useState } from "react";
import { Input } from "../ui/input";
import { Eye, EyeOff } from "lucide-react";
import { useController } from "react-hook-form";

const PasswordInputContent = ({ isView, setIsView, inputProps }) => {
  return (
    <div className="relative flex items-center w-full" dir="ltr">
      <Input
        {...inputProps}
        type={isView ? "text" : "password"}
        id="password"
        className={`${inputProps.className || ""} pr-10`}
      />
      <button
        type="button"
        className="absolute right-3 top-1/2 -translate-y-1/2 z-10 cursor-pointer text-muted-foreground hover:text-foreground transition-colors"
        onClick={() => setIsView(!isView)}
      >
        {isView ? (
          <Eye className="w-5 h-5" />
        ) : (
          <EyeOff className="w-5 h-5" />
        )}
      </button>
    </div>
  );
};

// Component that uses useController
const ControlledInputPassword = ({ name, control, ...props }) => {
  const [isView, setIsView] = useState(false);
  const { field } = useController({
    name,
    control,
    defaultValue: "",
  });

  return (
    <PasswordInputContent
      isView={isView}
      setIsView={setIsView}
      inputProps={{
        ...field,
        placeholder: props.placeholder,
        className: props.className,
      }}
    />
  );
};

// Component that uses direct field props
const UncontrolledInputPassword = ({ onChange, value, className, placeholder, ...restProps }) => {
  const [isView, setIsView] = useState(false);
  
  return (
    <PasswordInputContent
      isView={isView}
      setIsView={setIsView}
      inputProps={{
        ...restProps,
        onChange,
        value: value || "",
        placeholder,
        className,
      }}
    />
  );
};

export const InputPassword = ({ name, control, ...props }) => {
  // If control and name are provided, use controlled component
  if (control && name) {
    return <ControlledInputPassword name={name} control={control} {...props} />;
  }

  // Otherwise, use uncontrolled component with direct field props
  return <UncontrolledInputPassword {...props} />;
};
